import { takeLatest, put, call, fork } from 'redux-saga/effects';
import callApi from 'utils/api';
import * as actionTypes from './constants';

import { documentsSuccess, documentsFailure } from './documents-actions';

export function* fetchDocuments(action) {
  try {
    const results = yield call(callApi, {
      endpoint: `documents?orderId=${action.payload.id}`,
      options: {
        errorMessage: 'Could not get documents',
        retryAction: action,
      },
    });
    yield put(documentsSuccess(results));
  } catch (err) {
    yield put(documentsFailure(err));
  }
}

function* watchFetchDocuments() {
  yield takeLatest(actionTypes.DOCUMENTS_REQUEST, fetchDocuments);
}

export default [fork(watchFetchDocuments)];
